import axios from 'axios'
import store from '@/store'
import router from '@/router'
import Vue from 'vue'

export const interceptorsAxios = () => {
  axios.interceptors.request.use((config) => {
    // Start Loading
    store.commit('ui/startLoadingMutation', null, {root: true})
    // Reset is edit
    store.commit('ui/resetIsEditMutation', null, {root: true})
    // Add token to request ?
    const storeRef: any = store
    const token = storeRef.state.auth.token
    config.headers.Authorization = token ? `Bearer ${token}` : ''
    return config
  })
  axios.interceptors.response.use(
    (response) => {
      store.commit('ui/stopLoadingMutation', null, {root: true})
      return response
    },
    function (error) {
      store.commit('ui/stopLoadingMutation', null, {root: true})
      // No response Api server
      if (!error.response) {
        Vue.notify({
          group: 'user',
          type: 'error',
          title: 'Erreur',
          text: 'Le serveur ne répond pas'
        })
        return
      }
      const {data} = error.response
      if (!data) return
      if (data && error.response.status === 401) {
        if (data.type === 'error') {
          Vue.notify({
            group: 'user',
            type: 'error',
            title: 'Authentification',
            text: data.message
          })
        }
        router.replace('/auth/login')
      }
      if (data && error.response.status === 422) {
        if (data.type === 'validation') {
          Vue.notify({
            group: 'user',
            type: 'warn',
            title: 'Validation des champs',
            text: data.validations[0].message
          })
        }
      }
      if (data && error.response.status === 500) {
        if (data.type === 'error') {
          let text = data.message
          if (data.debug) {
            const debug = data.debug
            const stripped = debug.replace(/</g, '[')
            const stripped2 = stripped.replace(/>/g, ']')
            text += ` (${stripped2})`
          }
          Vue.notify({
            group: 'user',
            type: 'error',
            title: 'Erreur',
            text: text
          })
        } else {
          Vue.notify({
            group: 'user',
            type: 'error',
            title: 'Erreur',
            text: "Une erreur interne s'est produite"
          })
        }
      }
      return Promise.reject(error)
    }
  )
}
